// var styleguide = require('./modules/style-guide.js');
var aos = require('./modules/aos.js');
var accordions = require('./modules/accordions.js');
var cards = require('./modules/cards.js');
var fancybox = require('./modules/fancybox.js');
var menu = require('./modules/menu.js');
var resources = require('./modules/resources.js');
var sliders = require('./modules/sliders.js');
var svg = require('./modules/svg.js');

// Make sure that you init the styleguide first.
aos.init();
// styleguide.init();
accordions.init();
cards.init();
fancybox.init();
menu.init();
if (document.querySelector('body.page-template-resources')) {
	resources.init();
}
sliders.init();
svg.init();
